/**
 * @module:  Blog skeleton
 * @author Liang Huang
 * @date 2020-11-10 16:17:10
 */
import React, { Fragment } from 'react';
import ContentLoader from 'react-content-loader';
import SkeletonCard from '../Card'; // const paddingLeft = 16;
// const paddingTop = 12;
// const lineHeight = 20;

var SkeletonBlog = function SkeletonBlog() {
  return (
    /*#__PURE__*/
    React.createElement(Fragment, null,
    /*#__PURE__*/
    React.createElement("div", {
      className: "SkeletonBlog"
    },
    /*#__PURE__*/
    React.createElement(ContentLoader // speed={2}
    , {
      viewBox: "16 16 100% 200",
      width: "100%",
      height: 200
    },
    /*#__PURE__*/
    React.createElement("rect", {
      x: 0,
      y: 0,
      width: "100%",
      height: 200
    })),
    /*#__PURE__*/
    React.createElement(SkeletonCard, null),
    /*#__PURE__*/
    React.createElement(SkeletonCard, null),
    /*#__PURE__*/
    React.createElement(SkeletonCard, null)))
  );
};

export default SkeletonBlog;